import React from 'react'
import { ErrorMessage, Field } from 'formik'
import createClassName from '@utils/createClassName'
import { RadioButtonProps } from './types'

const RadioButton: React.FC <RadioButtonProps> = ({ label, name, value, error }) => {

    const inputClasses = createClassName(['formRadioButton', name], [error && 'error'])

    return(

        <>
            <div className = {inputClasses}>
                <label htmlFor = {name}>
                    <Field
                        type = "radio"
                        name = {name}
                    />

                    {label}
                </label>

                <ErrorMessage name = {name} className = "error" component = "h6" />
            </div>
        </>

    )

}

export default RadioButton